// FETCH ALL PROCESS_FLOW
export const FETCH_PROCESS_FLOW_REQUEST_DK = 'FETCH_PROCESS_FLOW_REQUEST_DK';
export const FETCH_PROCESS_FLOW_SUCCESS_DK = 'FETCH_PROCESS_FLOW_SUCCESS_DK';
export const FETCH_PROCESS_FLOW_FAILURE_DK = 'FETCH_PROCESS_FLOW_FAILURE_DK';

// FETCH ALL PROCESS_FLOW
export const FETCH_PROCESS_FLOW_WITHOUT_ID_REQUEST_DK = 'FETCH_PROCESS_FLOW_WITHOUT_ID_REQUEST_DK';
export const FETCH_PROCESS_FLOW_WITHOUT_ID_SUCCESS_DK = 'FETCH_PROCESS_FLOW_WITHOUT_ID_SUCCESS_DK';
export const FETCH_PROCESS_FLOW_WITHOUT_ID_FAILURE_DK = 'FETCH_PROCESS_FLOW_WITHOUT_ID_FAILURE_DK';

// CREATE PROCESS_FLOW
export const CREATE_PROCESS_FLOW_REQUEST_DK = 'CREATE_PROCESS_FLOW_REQUEST_DK';
export const CREATE_PROCESS_FLOW_SUCCESS_DK = 'CREATE_PROCESS_FLOW_SUCCESS_DK';
export const CREATE_PROCESS_FLOW_FAILURE_DK = 'CREATE_PROCESS_FLOW_FAILURE_DK';

// UPDATE PROCESS_FLOW
export const UPDATE_PROCESS_FLOW_REQUEST_DK = 'UPDATE_PROCESS_FLOW_REQUEST_DK';
export const UPDATE_PROCESS_FLOW_SUCCESS_DK = 'UPDATE_PROCESS_FLOW_SUCCESS_DK';
export const UPDATE_PROCESS_FLOW_FAILURE_DK = 'UPDATE_PROCESS_FLOW_FAILURE_DK';

// FETCH SINGLE STATE OF PROCESS_FLOW
export const FETCH_SINGLE_PROCESS_FLOW_REQUEST_DK = 'FETCH_SINGLE_PROCESS_FLOW_REQUEST_DK';
export const FETCH_SINGLE_PROCESS_FLOW_SUCCESS_DK = 'FETCH_SINGLE_PROCESS_FLOW_SUCCESS_DK';
export const FETCH_SINGLE_PROCESS_FLOW_FAILURE_DK = 'FETCH_SINGLE_PROCESS_FLOW_FAILURE_DK';

// FETCH SINGLE STATE OF PROCESS_FLOW
export const FETCH_PROCESS_FLOW_DATA_FROM_PROPERTY_REQUEST_DK = 'FETCH_PROCESS_FLOW_DATA_FROM_PROPERTY_REQUEST_DK';
export const FETCH_PROCESS_FLOW_DATA_FROM_PROPERTY_SUCCESS_DK = 'FETCH_PROCESS_FLOW_DATA_FROM_PROPERTY_SUCCESS_DK';
export const FETCH_PROCESS_FLOW_DATA_FROM_PROPERTY_FAILURE_DK = 'FETCH_PROCESS_FLOW_DATA_FROM_PROPERTY_FAILURE_DK';

// FETCH ALL PROCESS_FLOW
export const FETCH_SEQUENCE_NUMBER_REQUEST_DK = 'FETCH_SEQUENCE_NUMBER_REQUEST_DK';
export const FETCH_SEQUENCE_NUMBER_SUCCESS_DK = 'FETCH_SEQUENCE_NUMBER_SUCCESS_DK';
export const FETCH_SEQUENCE_NUMBER_FAILURE_DK = 'FETCH_SEQUENCE_NUMBER_FAILURE_DK';

// DELETE PROCESS_FLOW
export const DELETE_PROCESS_FLOW_REQUEST_DK = 'DELETE_PROCESS_FLOW_REQUEST_DK';
export const DELETE_PROCESS_FLOW_SUCCESS_DK = 'DELETE_PROCESS_FLOW_SUCCESS_DK';
export const DELETE_PROCESS_FLOW_FAILURE_DK = 'DELETE_PROCESS_FLOW_FAILURE_DK';

export const RESET_PROCESS_FLOW_INFO_DK = 'RESET_PROCESS_FLOW_INFO_DK';

export const CREATE_PROCESS_FLOW_FORM_DK = 'CREATE_PROCESS_FLOW_FORM_DK';

export const UPDATE_PROCESS_FLOW_FORM_DK = 'UPDATE_PROCESS_FLOW_FORM_DK';

// NAVIGATE TO PROCESS_FLOW DETAILS COMPONENT
export const NAVIGATE_PROCESS_FLOW_ADD_ON_DK = 'NAVIGATE_PROCESS_FLOW_ADD_ON_DK';

// NAVIGATE TO PROCESS_FLOW DETAILS COMPONENT
export const NAVIGATE_PROCESS_FLOW_SUPPLIER_DK = 'NAVIGATE_PROCESS_FLOW_SUPPLIER_DK';

// NAVIGATE TO PROCESS_FLOW COMPONENT
export const NAVIGATE_PROCESS_FLOW_DK = 'NAVIGATE_PROCESS_FLOW_DK';
